<template>
  <article class="personalcenter_page">
    <section class="userinfo">
      <img
        class="userinfo_avatar"
        v-if="userData.HeadPic == ''"
        src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1533532831339&di=a8d7e1d83509b25b5556723243fc56e7&imgtype=0&src=http%3A%2F%2Fwww.ghost64.com%2Fqqtupian%2FzixunImg%2Flocal%2F2017%2F09%2F19%2F15058040281604.jpg"
      />
      <img class="userinfo_avatar" v-else :src="userData.HeadPic" />

      <p>
        <span class="userinfo_nickname">{{ userData.NickName }}</span>
        <i class="iconfont icon-VIP vipicon" v-if="userData.IsVip"></i>
      </p>
    </section>

    <section class="mylist">
      <button class="mylist_item flex_wrap j_c_between my_passenger_information" @click="showMyContact">
        <i class="iconfont icon-wodeziliao1"></i>
        <span>我的乘客资料</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </button>
      <button class="mylist_item flex_wrap j_c_between" @click="showUserInfo">
        <i class="iconfont icon-bianji2"></i>
        <span>修改会员资料</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </button>
      <button class="mylist_item flex_wrap j_c_between" @click="showErrorTips">
        <i class="iconfont icon-jifen1"></i>
        <span>我的积分</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </button>
      <button class="mylist_item flex_wrap j_c_between" @click="showErrorTips">
        <i class="iconfont icon-huiyuanquanyi golden_color"></i>
        <span>会员权益及收费标准</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </button>
      <button class="mylist_item my_site flex_wrap j_c_between" @click="showMyAddress">
        <i class="iconfont icon-zhiyuandidian4"></i>
        <span>我的常用地址</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </button>
      <button class="mylist_item flex_wrap j_c_between" @click="showErrorTips">
        <i class="iconfont icon-youhuiquan2"></i>
        <span>我的优惠券</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </button>
    </section>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import userApi from '@/request/userApi';
export default {
  name: 'MyUserSetting',
  data() {
    return {};
  },
  mounted() {
    if (!this.userData) {
      this.$store.dispatch('user/getUserData');
    }
  },
  methods: {
    DateMinus(sDate) {
      var sdate = new Date(sDate.replace(/-/g, '/'));
      var now = new Date();
      var days = sdate.getTime() - now.getTime();
      var day = parseInt(days / (1000 * 60 * 60 * 24));
      return day;
    },
    getUserInfo() {
      var that = this;
      this.$Spin.show();
      this.$http
        .get(host + 'user/getUserData', {
          params: {
            openid: OpenId
          }
        })
        .then(function(response) {
          if (response.body.success) {
            response.body.data.LastVipDays = that.DateMinus(formatDateStr(response.body.data.VipEndDate, 'date'));
            that.userData = response.body.data;
          }
          that.$Spin.hide();
        }),
        function(fail) {
          console.log(fail);
        };
    },
    showMyContact() {
      this.$router.push({
        name: 'MyContactManager',
        params: {
          mode: 'add'
        }
      });
    },
    showMyAddress() {
      this.$router.push({
        name: 'MyAddressManager',
        params: {
          mode: 'add'
        }
      });
    },
    showErrorTips() {
      alert('功能开发中，敬请期待。');
    },
    showUserInfo() {
      // this.$router.push({
      //   name: 'UserInfoBind'
      // });
      alert('功能开发中，敬请期待。');
    }
  },
  computed: mapState({
    userData: state => state.user.UserData
  })
};
</script>

<style lang="less" scoped>
@import '../style/public';
.userinfo {
  .flex_wrap(center, center, initial, column);
}
.userinfo {
  background-color: #006535;
  width: 100%;
  height: 22vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 1em 0;
  /* position: relative */
}
.userinfo > p {
  font-size: 0.4rem;
  margin-top: 10px;
}
.vipicon {
  /* position: absolute;
    right: 40%;
    bottom: 32%; */
  font-size: 0.5rem !important;
  margin: 0 0 0 5px !important;
  background: linear-gradient(45deg, #ffd900 20%, #fff 50%, #ffd700 80%);
  -webkit-background-clip: text;
  color: transparent;
  /* color: #ffd700 */
}
.userinfo_avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  /*margin: 1em;*/
}
.mylist {
  flex: 1;
  overflow: auto;
}
.mylist_item {
  width: 100%;
  padding: 0 3%;
  font-size: 0.45rem;
  border: none;
  line-height: 8vh;
  background-color: #f8f8f8;
  border-bottom: 1px solid #888;
  .flex_wrap(space-between, center);
}
.mylist_item > i {
  font-size: 0.6rem;
  flex: 0 0 10%;
}
.mylist_item > span {
  flex: 1;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/MyUserSetting.vue